<div class="detail-panel">
  <div class="flex justify-end items-center">
    <button (click)="close()" class="button button-primary button-sm" title="Cerrar detalles">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </div>
  
  <h2 class="text-primary-500">{{ client?.razonSocial }}</h2>

  <ul>
    <li>
      <strong>ID:</strong> {{ client?.id }}
    </li>
    <li>
      <strong>RUT:</strong> {{ client?.rut }}
    </li>
    <li>
      <strong>Razón Social:</strong> {{ client?.razonSocial }}
    </li>
    <li>
      <strong>Giro:</strong> {{ client?.giro }}
    </li>
    <li>
      <strong>Dirección Legal:</strong><br>
      {{ client?.direccionLegal }}
    </li>
    <li>
      <strong>Dirección de Despacho:</strong><br>
      {{ client?.direccionDespacho }}
    </li>
    <li>
      <strong>Estado:</strong> {{ client?.disabled ? 'Deshabilitado' : 'Habilitado' }}
    </li>
  </ul>

  <div class="flex justify-center mt-6 space-x-4">
    <button (click)="close()" class="button button-outlined-primary">Cancelar</button>
    <a [routerLink]="['/clients/update', client?.id]" class="button button-primary">Editar</a>
  </div>
</div>
